/* Tradeline related products + recently viewed. Depends on window.Tradeline (tl-theme.js). */
(() => {
  const T = window.Tradeline || (window.Tradeline = {});

  const whenVisible = (el, fn) => {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); fn(); }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  };

  const syncToggles = () => {
    // Re-apply wishlist/compare pressed state to freshly inserted cards.
    if (T.emit && T.wishlist) T.emit('tl:wishlist:changed', { items: T.wishlist.items() });
  };

  /* "You may also like": lazy Section Rendering fetch of intent=related recommendations. */
  class TlRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      whenVisible(this, () => this.load());
    }

    async load() {
      this.loaded = true;
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-recs-content]');
        const target = this.querySelector('[data-recs-content]');
        if (!fresh || !fresh.querySelector('.tl-card')) { this.hideSection(); return; }
        target.innerHTML = fresh.innerHTML;
        syncToggles();
      } catch (e) {
        this.hideSection();
      }
    }

    hideSection() {
      if (window.Shopify && Shopify.designMode) return;
      const wrapper = this.closest('.shopify-section') || this;
      wrapper.hidden = true;
    }
  }

  /* Recently viewed: handles stored by tl-theme.js; each card comes from /products/<handle>?view=card. */
  class TlRecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-rv-list]');
      const clear = this.querySelector('[data-rv-clear]');
      if (clear) clear.addEventListener('click', () => {
        if (T.store) T.store.set('recent', []);
        this.list.innerHTML = '';
        this.toggle(false);
      });
      // The section starts hidden (nothing to observe yet), so render once the browser is idle.
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
      idle(() => this.render());
    }

    handles() {
      const current = this.dataset.current;
      const limit = Number(this.dataset.limit || 8);
      const all = T.recentlyViewed ? T.recentlyViewed.items() : [];
      return all.filter((h) => h && h !== current).slice(0, limit);
    }

    async render() {
      const handles = this.handles();
      if (!handles.length) { this.toggle(false); return; }
      const root = (T.routes && T.routes.root ? T.routes.root : '/').replace(/\/$/, '');
      const cards = await Promise.all(handles.map(async (handle) => {
        try {
          const res = await fetch(`${root}/products/${encodeURIComponent(handle)}?view=card`);
          if (!res.ok) return null;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.tl-card');
        } catch (e) { return null; }
      }));
      const found = cards.filter(Boolean);
      // Drop handles that no longer resolve (deleted or unpublished products).
      if (found.length !== handles.length && T.store && T.recentlyViewed) {
        const ok = new Set(found.map((c) => c.dataset.productHandle));
        const missing = handles.filter((h) => !ok.has(h));
        T.store.set('recent', T.recentlyViewed.items().filter((h) => !missing.includes(h)));
      }
      this.list.innerHTML = '';
      found.forEach((card) => {
        const li = document.createElement('li');
        li.className = 'tl-row__item';
        li.appendChild(document.adoptNode(card));
        this.list.appendChild(li);
      });
      this.toggle(found.length > 0);
      syncToggles();
    }

    toggle(show) {
      const empty = this.querySelector('[data-rv-empty]');
      const clear = this.querySelector('[data-rv-clear]');
      if (empty) empty.hidden = show;
      if (clear) clear.hidden = !show;
      if (window.Shopify && Shopify.designMode) { this.hidden = false; return; }
      this.hidden = !show;
    }
  }

  if (!customElements.get('tl-recommendations')) customElements.define('tl-recommendations', TlRecommendations);
  if (!customElements.get('tl-recently-viewed')) customElements.define('tl-recently-viewed', TlRecentlyViewed);
})();
